import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { PingPanel } from "./components/PingPanel.tsx";
import { ApiError, api } from "./lib/api.ts";

/** How often the SPA re-pings on its own. Fast enough to notice the backend
 *  going away, slow enough to leave an idle tab alone. */
const PING_MS = 15_000;

/** How often the relative labels ("4 minutes ago") are recomputed. */
const CLOCK_MS = 10_000;

export function App() {
  const ping = useQuery({
    queryKey: ["ping"],
    queryFn: () => api.ping(),
    refetchInterval: PING_MS,
    // A failed ping IS the answer here, so don't sit on retries before showing
    // it, and keep the last good response visible while re-checking.
    retry: false,
  });

  // The heartbeat ages between responses, so the clock has to move on its own —
  // otherwise "just now" stays on screen for a quarter of an hour.
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), CLOCK_MS);
    return () => clearInterval(id);
  }, []);

  const error =
    ping.error instanceof ApiError
      ? ping.error.message
      : ping.error
        ? "something went wrong"
        : null;

  return (
    <main className="mx-auto flex min-h-full w-full max-w-2xl flex-col gap-8 px-5 py-12">
      <header className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold tracking-tight">josh-mono</h1>
        <p className="text-sm text-ink-muted">
          A Vite SPA pinging a Bun API, with a BullMQ worker ticking on a schedule.
        </p>
      </header>

      <PingPanel
        data={ping.data ?? null}
        error={error}
        pending={ping.isFetching}
        onPing={() => void ping.refetch()}
        now={now}
      />

      <p className="text-xs text-ink-muted">
        The SPA only pings. The schedule lives in the backend: one repeating job, declared once at
        boot, that logs the time and records it. The panel re-pings every {PING_MS / 1000}s.
      </p>
    </main>
  );
}
